import { firstValueFrom } from 'rxjs';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { AppConfigService } from '@core/services/config/app-config.service';
import { MatDialog } from '@angular/material/dialog';
import { ErrorRecoveryDialogComponent } from '@core/components/error-recovery-dialog/error-recovery-dialog.component';

@Injectable({ providedIn: 'root' })
export class SentryErrorHandler extends ErrorHandler {
  private _appConfig = inject(AppConfigService);
  private _isDialogOpen = false;
  private _dialog = inject(MatDialog);
  trackingOn = this._appConfig.config.errorTracking;

  constructor() {
    super();
    console.log(`Error Reporting is ${this.trackingOn ? 'On' : 'Off'}!`);
  }
  handleError(error) {
    if (
      this.trackingOn &&
      !error.message.includes('ExpressionChangedAfterItHasBeenCheckedError') &&
      !error.message.includes('WebSocket closed with status code: 1006')
    ) {
      // Always capture the error to Sentry regardless of dialog state
      const eventId = Sentry.captureException(error.originalError || error);

      // Only show dialog if one isn't already open
      if (!this._isDialogOpen) {
        this._isDialogOpen = true;

        Sentry.showReportDialog({
          eventId,
          subtitle2:
            "If you'd like to help, tell us what happened below. The application may be in an unstable state and could behave unexpectedly until refreshed.",
          onClose: async () => {
            this._isDialogOpen = false; // Reset dialog state
            ErrorRecoveryDialogComponent.open(this._dialog);
          },
        });
      }
    }
    super.handleError(error);
  }
}
